// NOTE: Update hidden_ids to include all keys of bundleMapping
const bundleMapping = {
    // Men's Gi - Ultralight, Blue
    "7467095425093": {
        "jacket": 7929069011013,
        "pants": 7929100632133
    },
    // Men's Gi - Ultralight, White
    "7467093753925": {
        "jacket": 7929069011013,
        "pants": 7929100632133
    },
    // Men's Gi - Kitsune, Black
    "7939900375109": {
        "jacket": 7929144934469,
        "pants": 7929146703941
    },
    // Women's Gi - Kitsune, Black
    "7939971907653": {
        "jacket": 7929153290309,
        "pants": 7929154601029
    },
    // Women's Gi - Antoinette, Black
    "7241777152069": {
        "jacket": 7929494110277,
        "pants": 7929498828869
    },
    // Women's Gi - Antoinette, White
    "6917299077189": {
        "jacket": 7929494110277,
        "pants": 7929498828869
    },
    // Women's Gi - Flores, Black
    "7894442344517": {
        "jacket": 7894405546053,
        "pants": 7894405644357
    },
    // Women's Gi - Flores, White
    "7894497394757": {
        "jacket": 7894405546053,
        "pants": 7894405644357
    }
};

function sizeRecButtonForProductID(productID) {
    return `<div vw-theme-entry="fit-match-button" style="display: none; float: right;">
                <button class="vw-fit-match-button" vw-product-id="${productID}" type="button">What's my fit?</button>
            </div>`
}

function linkBundles(productID) {
    const mapping = bundleMapping[productID];
    if (!mapping) {
        return false;
    }
 
    const { jacket: jacketID, pants: pantsID } = mapping;
    const container = document.querySelector('[data-simple-bundles-options]');
    if (!container) {
        return false;
    }

    const removeButtons = () => {
        const container = document.querySelector('[data-simple-bundles-options]');
        const jacketLabel = container.querySelector('label[for="jacket---size"]') ?? container.querySelector('label[for="jacket-size"]');
        const pantsLabel = container.querySelector('label[for="pants---size"]') ?? container.querySelector('label[for="pants-size"]');
        const vwEntryJacket = jacketLabel && jacketLabel.nextElementSibling.hasAttribute('vw-theme-entry') ? jacketLabel.nextElementSibling : null;
        if (vwEntryJacket) {
            console.warn('removing')
            vwEntryJacket.remove();
        }
    };

    const insertButtons = () => {
        const container = document.querySelector('[data-simple-bundles-options]');
        const jacketLabel = container.querySelector('label[for="jacket---size"]') ?? container.querySelector('label[for="jacket-size"]');
        const pantsLabel = container.querySelector('label[for="pants---size"]') ?? container.querySelector('label[for="pants-size"]');

        if (jacketLabel && (!jacketLabel.nextElementSibling || !jacketLabel.nextElementSibling.hasAttribute('vw-theme-entry'))) {
            console.warn('inserting')
            jacketLabel.insertAdjacentHTML('afterend', sizeRecButtonForProductID(jacketID));
        }
        if (pantsLabel && (!pantsLabel.nextElementSibling || !pantsLabel.nextElementSibling.hasAttribute('vw-theme-entry'))) {
            pantsLabel.insertAdjacentHTML('afterend', sizeRecButtonForProductID(pantsID));
        }

        if (window.vwFunctions) {
            console.warn('resetting…')
            window.vwFunctions.reset()
        };
    };

    // Initial insertion
    insertButtons();

    // Observe container for changes to reinstate buttons if removed
    const observer = new MutationObserver(() => {
        observer.disconnect()
        setTimeout(() => {
            removeButtons();
            insertButtons();
        }, 200);
    });

    observer.observe(container, { childList: true, subtree: true });
    return true;
}

document.addEventListener('DOMContentLoaded', function () {
    const maxAttempts = 10; // Will reach ~60 seconds total
    const baseDelay = 1000; // Start with 1000ms
    
    function attemptLinkBundles(attempt = 1) {
        const el = document.getElementById('vestico-product-data');
        if (el) {
            try {
                const productID = el.dataset.productId;
                const result = linkBundles(productID);
                
                if (result) {
                    return;
                }
            } catch (error) {
                console.error('Error in linkBundles:', error);
            }
        }
        
        if (attempt <= maxAttempts) {
            const delay = baseDelay * Math.pow(2, attempt - 1); // Exponential backoff
            console.log(`Attempt ${attempt} failed, retrying in ${delay}ms`);
            setTimeout(() => attemptLinkBundles(attempt + 1), delay);
        } else {
            console.error('linkBundles failed after maximum attempts');
        }
    }
    
    // Start the first attempt after 100ms
    setTimeout(() => attemptLinkBundles(1), 100);
  
});
